module.exports = __webpack_public_path__ + "img/green-success-circle-lg.931544d8.svg";